import MarkerClusterGroup from 'react-leaflet-cluster';
import { m } from 'framer-motion';
import { useState, useMemo, useRef, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Container } from '@mui/system';
import { MapContainer, TileLayer, Marker, Tooltip } from 'react-leaflet';
import { Box, Grid, Typography } from '@mui/material';
import { PropTypes } from 'prop-types';
import L from 'leaflet';

// import MarkerClusterGroup from 'react-leaflet-markercluster';
//  import { varFade } from '../../animate';
import MotionContainer from '../../animate/MotionContainer';

import pinRed from '../../../assets/images/icons/map/pin1W.svg';
import pinBlue from '../../../assets/images/icons/map/pin2W.svg';
// import pinYellow from '../../../assets/images/icons/map/pin3W.svg';

import useLocales from '../../../hooks/useLocales';

DetailMap.propTypes = {
  title: PropTypes.string,
  markers: PropTypes.array,
  nocopy: PropTypes.bool,
  nopadding: PropTypes.bool,
  noscroll: PropTypes.bool,
  type: PropTypes.number,
  center: PropTypes.array,
};

const RootStyle = styled('div')(({ theme }) => ({
  // padding: theme.spacing(6, 0),
  backgroundColor: theme.palette.background.paper,
}));

// ----------------------------------------------------------------------

export default function DetailMap({
  title,
  markers,
  nocopy = false,
  nopadding = false,
  noscroll = true,
  type = 0,
  center = [48.714041, 19.712934],
}) {
  const { translate } = useLocales();

  const [mapRef, setMapRef] = useState({ current: null });
  const customAreaRef = useRef(null);
  useEffect(() => {
    const container = L.DomUtil.get('map');
    if (container != null) {
      container._leaflet_id = null;
    }
  }, []);

  useEffect(() => {
    if (mapRef.current && customAreaRef.current) {
      mapRef.current.fitBounds(customAreaRef.current.getBounds(), { maxZoom: 14 });
    }
  }, [markers, mapRef]);

  const createClusterCustomIcon = function fn(cluster) {
    return L.divIcon({
      html: `<span>${cluster.getChildCount()}</span>`,
      className: 'customMarker',
      iconSize: L.point(55, 55, true),
      iconAnchor: [28, 55],
    });
  };

  const mapCreateHandler = (map) => {
    setMapRef({ current: map });
    // map.fitBounds(customAreaRef.current.getBounds());
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const markerClickHandler = (marker) => {
    if (!nocopy) {
      navigator.clipboard.writeText(`
        ${marker.title}, ${marker.address}, [ ${marker.position[0]}, ${marker.position[1]} ]
      `);
    }
  };

  const content = useMemo(
    () => (
      <Box sx={{ marginTop: '46px', marginBottom: '16px' }}>
        {title && (
          <Grid container sx={{ padding: '16px 8px' }}>
            <Typography variant="h4">{title}</Typography>
          </Grid>
        )}
        <MapContainer
          style={{ height: '400px', borderRadius: '12px' }}
          className="map"
          key={center}
          center={center}
          zoom={10}
          maxZoom={18}
          whenCreated={mapCreateHandler}
          scrollWheelZoom={noscroll}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          />
          <MarkerClusterGroup
            ref={customAreaRef}
            // eventHandlers={{ clusterclick: (e) => handleCluster(e) }}
            zoomToBoundsOnClick={false}
            spiderfyOnMaxZoom={false}
            showCoverageOnHover={false}
            iconCreateFunction={(e) => createClusterCustomIcon(e)}
          >
            {markers.map((item, idx) => (
              <Marker
                key={idx}
                alt={idx}
                position={item.position}
                eventHandlers={{ click: () => markerClickHandler(item) }}
                icon={L.icon({
                  // eslint-disable-next-line no-nested-ternary
                  iconUrl: type === 2 ? pinBlue : pinRed,
                  iconSize: new L.Point(48, 48),
                  iconAnchor: new L.Point(24, 48),
                })}
              >
                <Tooltip direction="bottom" offset={[0, 20]} opacity={1} sx={{ borderRadius: '15px' }}>
                  <Typography variant="body1" sx={{ color: 'black' }}>
                    <b>{translate('articles.name')}:</b> {item.title}
                  </Typography>
                  {item.address !== '' && (
                    <Typography variant="body1" sx={{ color: 'black' }}>
                      <b>{translate('articles.address')}:</b> {item.address}
                    </Typography>
                  )}
                  <Typography variant="body1" sx={{ color: 'black' }}>
                    <b>{translate('articles.position')}:</b> [ {item.position[0]}, {item.position[1]} ]
                  </Typography>
                  {/* {!nocopy && <Typography variant="subtitle2">{translate('articles.clickToCopy')}</Typography>} */}
                </Tooltip>
              </Marker>
            ))}
          </MarkerClusterGroup>
        </MapContainer>
        {/* {!nocopy && (
          <Typography variant="subtitle2" align="center">
            {translate('articles.clickToCopy')}
          </Typography>
        )} */}
      </Box>
    ),
    [center, markerClickHandler, markers, noscroll, title, translate, type]
  );
  // ));

  return nopadding ? (
    content
  ) : (
    <RootStyle className="printable">
      <Container component={MotionContainer} sx={{ position: 'relative' }}>
        <m.div /* variants={varFade().inUp} */>{content}</m.div>
      </Container>
    </RootStyle>
  );
}
